var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-cards",
    {
      attrs: {
        "is-link": "",
        link: _vm.defaultVersion.productSheetUrl,
        "data-oevent-category": "selecteur_produit",
        "data-oevent-action": "bloc_" + _vm.accessory.name.split(" ").join("_"),
        "data-oevent-label": _vm.defaultVersion.productSheetUrl,
      },
    },
    [
      _vm.showBanner()
        ? _c("ob1-tag", {
            staticClass: "banner",
            attrs: { label: _vm.defaultVersion.banner.label },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row pt-1" }, [
        _c("div", { staticClass: "img-mobile mt-1 mb-2 mx-1" }, [
          _c(
            "div",
            { staticClass: "d-flex img-container" },
            [
              _c("selector-color-chips", {
                attrs: { colors: _vm.accessory.colors },
              }),
              _vm._v(" "),
              _vm.defaultVersion.mainImage
                ? _c("ob1-picture", {
                    staticClass: "accessoryPicture",
                    attrs: { visual: _vm.defaultVersion.mainImage },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "infos d-flex align-items-start flex-column" },
          [
            _c(
              "div",
              { staticClass: "infos-accessory" },
              [
                _c(
                  "h2",
                  { staticClass: "no-signature standard py-0 my-0 fw-normal" },
                  [
                    _c("strong", { staticClass: "standard" }, [
                      _vm._v(_vm._s(_vm.accessory.name)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.defaultVersion.reviews
                  ? _c("ob1-rating", {
                      attrs: {
                        average: _vm.defaultVersion.reviews.average,
                        "with-score": true,
                        "rating-results-height": 1.01,
                        "font-size": 0.875,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.accessory.versions.length > 0
              ? _c(
                  "div",
                  { staticClass: "infos-price mt-auto" },
                  [
                    _vm.accessory.status !== null &&
                    _vm.accessory.status.label !== null
                      ? _c("ob1-tag", {
                          staticClass: "mt-1 mt-md-0",
                          attrs: {
                            type: "unavailable",
                            label: _vm.accessory.status.label,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ob1-prix-terminal", {
                      attrs: {
                        "multiple-price": _vm.accessory.versions.length > 1,
                        "compact-price": true,
                        "total-price-with-promo":
                          _vm.defaultVersion.discountedPriceInCents,
                        "total-price-without-promo": _vm.getPriceWithoutPromo(),
                        "is-cents-format": true,
                        "payment-info-label": _vm.defaultVersion
                          .paymentInfoLabel
                          ? _vm.defaultVersion.paymentInfoLabel.label
                          : null,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row infos-advantage px-1" },
        [
          _vm.defaultVersion.odrMessage
            ? _c("ob1-message-complementaire", {
                staticClass: "p-1",
                attrs: {
                  icon: "icon-rewards",
                  "is-reduced": true,
                  title: _vm.defaultVersion.odrMessage,
                  "has-alert-content": false,
                },
              })
            : _c("div", { staticClass: "pb-1" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }